(function() {
  'use strict';
  if (window.__spectrumWlInit) return;
  window.__spectrumWlInit = true;

  var GUEST_KEY = '__spectrum_wishlist_guest';

  /* === THEME CONFIG (modify per-store) === */
  /* THEME-SPECIFIC: Header badge element ID */
  var HEADER_BADGE_ID = 'lifelong-wishlist-badge';
  /* END THEME-SPECIFIC */

  /* ── Helpers ──────────────────────────────────────────────────────────── */

  function getLib() {
    var lib = (window.Spectrum && window.Spectrum.wishlist)
           || (window.__spectrumAi && window.__spectrumAi.lib && window.__spectrumAi.lib.wishlist);
    return lib && typeof lib.getWishlists === 'function' ? lib : null;
  }

  function isCustomerLoggedIn() {
    return !!(window.__spectrumAi && window.__spectrumAi.customer);
  }

  function waitForLib(callback, maxRetries) {
    var retries = 0;
    maxRetries = maxRetries || 15;
    function check() {
      var lib = getLib();
      if (lib) {
        callback(lib);
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(check, 200);
      }
    }
    check();
  }

  function getGuestGids() {
    try {
      var raw = localStorage.getItem(GUEST_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed.items)) return [];
      var seen = {};
      return parsed.items
        .map(function(i) { return i.shopifyProductGid; })
        .filter(function(gid) {
          if (!gid || seen[gid]) return false;
          seen[gid] = true;
          return true;
        });
    } catch(e) { return []; }
  }

  /* ── Header Count Badge ──────────────────────────────────────────────── */

  function updateHeaderCount(count) {
    /* THEME-SPECIFIC: Header badge selector */
    var el = document.getElementById(HEADER_BADGE_ID) || document.getElementById('spectrum-wl-header-count');
    /* END THEME-SPECIFIC */
    if (!el) return;
    el.textContent = count > 99 ? '99+' : count;
    if (count > 0) {
      el.style.display = '';
      el.removeAttribute('hidden');
    } else {
      el.style.display = 'none';
      el.setAttribute('hidden', '');
    }
  }

  /** Unwraps getWishlists() response into a plain array of list objects */
  function extractWishlists(result) {
    if (!result.ok) return [];
    var d = result.data;
    return (d && Array.isArray(d.wishlists)) ? d.wishlists
         : (d && d.data && Array.isArray(d.data.wishlists)) ? d.data.wishlists
         : Array.isArray(d) ? d : [];
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Cached Wishlists (used by picker to avoid re-fetching) ── */

  var cachedWishlists = null;

  /* ── Wishlist State Sync — hydrates is-wishlisted on card buttons ── */

  function syncWishlistState() {
    if (!isCustomerLoggedIn()) return;
    waitForLib(function(lib) {
      lib.getWishlists().then(function(result) {
        var lists = extractWishlists(result);
        cachedWishlists = result.ok ? lists : null;
        var wishedGids = {};
        var totalItems = 0;
        lists.forEach(function(l) {
          if (typeof l.itemCount === 'number') {
            totalItems += l.itemCount;
          }
          if (Array.isArray(l.items)) {
            l.items.forEach(function(item) {
              if (item.shopifyProductGid) wishedGids[item.shopifyProductGid] = true;
            });
            if (typeof l.itemCount !== 'number') {
              totalItems += l.items.length;
            }
          }
        });
        document.querySelectorAll('[data-spectrum-wishlist-btn]').forEach(function(el) {
          var gid = el.dataset.productGid;
          if (!gid) return;
          el.classList.toggle('is-wishlisted', !!wishedGids[gid]);
        });
        updateHeaderCount(totalItems || Object.keys(wishedGids).length);
      });
    });
  }

  /* ── Guest State Hydration ───────────────────────────────────────────── */

  function hydrateGuestState() {
    if (isCustomerLoggedIn()) return;
    var gids = getGuestGids();
    document.querySelectorAll('[data-spectrum-wishlist-btn]').forEach(function(el) {
      el.classList.toggle('is-wishlisted', gids.indexOf(el.dataset.productGid) !== -1);
    });
    updateHeaderCount(gids.length);
  }

  /* ── Multi-List Picker ──────────────────────────────────────────────── */

  var pickerEl = null;
  var pickerBackdrop = null;
  var pickerAnchor = null;
  var pickerGid = null;
  var pickerVariantGid = null;
  var pickerHandle = null;
  var pickerLists = [];

  function isProductInAnyList() {
    return pickerLists.some(function(list) {
      return Array.isArray(list.items) && list.items.some(function(i) {
        return i.shopifyProductGid === pickerGid;
      });
    });
  }

  function ensurePickerDOM() {
    if (pickerEl) return;

    pickerBackdrop = document.createElement('div');
    pickerBackdrop.className = 'spectrum-wl-picker-backdrop';
    document.body.appendChild(pickerBackdrop);

    pickerEl = document.createElement('div');
    pickerEl.className = 'spectrum-wl-picker';
    pickerEl.setAttribute('role', 'dialog');
    pickerEl.setAttribute('aria-label', 'Save to wishlist');
    pickerEl.innerHTML =
      '<div class="spectrum-wl-picker__header">Save to list<button type="button" class="spectrum-wl-picker__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>' +
      '<div class="spectrum-wl-picker__lists"></div>' +
      '<div class="spectrum-wl-picker__create">' +
        '<input type="text" class="spectrum-wl-picker__input" placeholder="New list name…" maxlength="50" aria-label="New list name">' +
        '<button type="button" class="spectrum-wl-picker__create-btn" aria-label="Create list">+</button>' +
      '</div>';
    document.body.appendChild(pickerEl);

    pickerEl.addEventListener('change', function(e) {
      if (e.target.type === 'checkbox' && e.target.dataset.listId) {
        handleCheckboxChange(e.target);
      }
    });

    pickerEl.querySelector('.spectrum-wl-picker__close').addEventListener('click', closePicker);
    pickerEl.querySelector('.spectrum-wl-picker__create-btn').addEventListener('click', handleCreateList);

    pickerEl.querySelector('.spectrum-wl-picker__input').addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); handleCreateList(); }
    });

    pickerEl.addEventListener('click', function(e) { e.stopPropagation(); });

    pickerBackdrop.addEventListener('click', closePicker);
  }

  function openPicker(anchor, lib, gid, variantGid, handle) {
    ensurePickerDOM();

    if (pickerEl.classList.contains('is-open') && pickerAnchor === anchor) {
      closePicker();
      return;
    }

    if (pickerEl.classList.contains('is-open')) {
      closePicker();
    }

    var anchorDialog = anchor.closest('dialog');
    var targetParent = anchorDialog || document.body;
    if (pickerEl.parentNode !== targetParent) {
      targetParent.appendChild(pickerBackdrop);
      targetParent.appendChild(pickerEl);
    }

    pickerAnchor = anchor;
    pickerGid = gid;
    pickerVariantGid = variantGid;
    pickerHandle = handle;
    pickerLists = [];

    pickerEl.querySelector('.spectrum-wl-picker__input').value = '';

    positionPicker(anchor);
    pickerEl.classList.add('is-open');
    pickerBackdrop.classList.add('is-open');
    if (!anchorDialog) document.body.style.overflow = 'hidden';

    if (cachedWishlists) {
      pickerLists = cachedWishlists;
      renderPickerLists(pickerLists, gid);
    } else {
      var listsContainer = pickerEl.querySelector('.spectrum-wl-picker__lists');
      listsContainer.innerHTML = '<div class="spectrum-wl-picker__loading"><div class="spectrum-wl-picker__spinner"></div></div>';
      lib.getWishlists().then(function(result) {
        if (!pickerEl.classList.contains('is-open') || pickerGid !== gid) return;
        pickerLists = extractWishlists(result);
        cachedWishlists = pickerLists;
        renderPickerLists(pickerLists, gid);
      });
    }
  }

  function positionPicker(anchor) {
    if (window.innerWidth < 750) {
      pickerEl.style.top = '';
      pickerEl.style.left = '';
      pickerEl.style.position = '';
      return;
    }

    var rect = anchor.getBoundingClientRect();
    var pickerWidth = 256;
    var vpWidth = document.documentElement.clientWidth;

    var anchorDialog = anchor.closest('dialog');
    if (anchorDialog) {
      var dialogRect = anchorDialog.getBoundingClientRect();
      var top = rect.bottom - dialogRect.top + 8;
      var left = rect.left - dialogRect.left + (rect.width / 2) - (pickerWidth / 2);
      if (left < 8) left = 8;
      if (left + pickerWidth > dialogRect.width - 8) left = dialogRect.width - pickerWidth - 8;
      pickerEl.style.position = 'absolute';
      pickerEl.style.top = top + 'px';
      pickerEl.style.left = left + 'px';
    } else {
      var scrollY = window.scrollY || document.documentElement.scrollTop;
      var scrollX = window.scrollX || document.documentElement.scrollLeft;
      var top = rect.bottom + scrollY + 8;
      var left = rect.left + scrollX + (rect.width / 2) - (pickerWidth / 2);
      if (left < 8) left = 8;
      if (left + pickerWidth > vpWidth - 8) left = vpWidth - pickerWidth - 8;
      pickerEl.style.position = 'absolute';
      pickerEl.style.top = top + 'px';
      pickerEl.style.left = left + 'px';
    }
  }

  function renderPickerLists(lists, gid) {
    var container = pickerEl.querySelector('.spectrum-wl-picker__lists');
    if (!lists.length) {
      container.innerHTML = '<div class="spectrum-wl-picker__empty">No lists yet. Create one below.</div>';
      return;
    }

    var html = '';
    lists.forEach(function(list) {
      var isInList = Array.isArray(list.items) && list.items.some(function(i) {
        return i.shopifyProductGid === gid;
      });
      var count = list.itemCount != null ? list.itemCount : (list.items ? list.items.length : 0);
      html += '<label class="spectrum-wl-picker__item">' +
        '<input type="checkbox" data-list-id="' + escapeHtml(list.id) + '"' + (isInList ? ' checked' : '') + '>' +
        '<span class="spectrum-wl-picker__name">' + escapeHtml(list.name || 'Unnamed') + ' (' + count + ')</span>' +
        '</label>';
    });
    container.innerHTML = html;
  }

  function closePicker() {
    if (!pickerEl || !pickerEl.classList.contains('is-open')) return;
    pickerEl.classList.remove('is-open');
    pickerBackdrop.classList.remove('is-open');
    if (pickerEl.parentNode === document.body) document.body.style.overflow = '';

    if (pickerAnchor && pickerLists.length) {
      var inAny = isProductInAnyList();
      document.querySelectorAll('[data-spectrum-wishlist-btn][data-product-gid="' + pickerGid + '"]').forEach(function(el) {
        el.classList.toggle('is-wishlisted', inAny);
      });
    }

    pickerAnchor = null;
  }

  function setItemLoading(checkbox, active) {
    var label = checkbox.closest('.spectrum-wl-picker__item');
    if (!label) return;
    if (active) {
      var spinner = document.createElement('span');
      spinner.className = 'spectrum-wl-picker__item-spinner';
      label.appendChild(spinner);
    } else {
      var existing = label.querySelector('.spectrum-wl-picker__item-spinner');
      if (existing) existing.remove();
    }
  }

  function handleCheckboxChange(checkbox) {
    var listId = checkbox.dataset.listId;
    var isChecked = checkbox.checked;
    var lib = getLib();
    if (!lib) return;

    checkbox.disabled = true;
    setItemLoading(checkbox, true);

    if (isChecked) {
      var wasInAnyList = isProductInAnyList();
      lib.addItem(listId, {
        shopifyProductGid: pickerGid,
        shopifyVariantGid: pickerVariantGid,
        handle: pickerHandle
      }).then(function(result) {
        checkbox.disabled = false;
        setItemLoading(checkbox, false);
        if (!result.ok) { checkbox.checked = false; return; }

        var list = pickerLists.find(function(l) { return l.id === listId; });
        if (list && Array.isArray(list.items)) {
          var newItem = { shopifyProductGid: pickerGid, shopifyVariantGid: pickerVariantGid, handle: pickerHandle };
          var rd = result.data;
          if (rd && rd.data) rd = rd.data;
          if (rd && rd.item) rd = rd.item;
          if (rd) newItem.id = rd.id || null;
          list.items.push(newItem);
          if (list.itemCount != null) list.itemCount++;
        }

        updatePickerItemCount(listId);
        document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
          detail: { action: 'added', productGid: pickerGid, isInAnyList: isProductInAnyList(), wasInAnyList: wasInAnyList }
        }));
      });
    } else {
      var list = pickerLists.find(function(l) { return l.id === listId; });
      var item = list && Array.isArray(list.items) && list.items.find(function(i) {
        return i.shopifyProductGid === pickerGid;
      });

      if (!item) {
        checkbox.checked = true;
        checkbox.disabled = false;
        return;
      }

      var removeCall = item.id
        ? lib.removeItem(listId, item.id)
        : lib.removeByProduct(pickerGid);

      removeCall.then(function(result) {
        checkbox.disabled = false;
        setItemLoading(checkbox, false);
        if (!result.ok) { checkbox.checked = true; return; }

        if (item.id) {
          if (list && Array.isArray(list.items)) {
            list.items = list.items.filter(function(i) { return i.shopifyProductGid !== pickerGid; });
            if (list.itemCount != null && list.itemCount > 0) list.itemCount--;
          }
          updatePickerItemCount(listId);
        } else {
          pickerLists.forEach(function(l) {
            if (Array.isArray(l.items)) {
              var before = l.items.length;
              l.items = l.items.filter(function(i) { return i.shopifyProductGid !== pickerGid; });
              var removed = before - l.items.length;
              if (l.itemCount != null) l.itemCount = Math.max(0, l.itemCount - removed);
            }
          });
          renderPickerLists(pickerLists, pickerGid);
        }

        document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
          detail: { action: 'removed', productGid: pickerGid, isInAnyList: isProductInAnyList() }
        }));
      });
    }
  }

  function updatePickerItemCount(listId) {
    if (!pickerEl) return;
    var list = pickerLists.find(function(l) { return l.id === listId; });
    if (!list) return;
    var count = list.itemCount != null ? list.itemCount : (list.items ? list.items.length : 0);
    var checkbox = pickerEl.querySelector('input[data-list-id="' + listId + '"]');
    if (!checkbox) return;
    var nameEl = checkbox.parentNode.querySelector('.spectrum-wl-picker__name');
    if (nameEl) {
      nameEl.textContent = (list.name || 'Unnamed') + ' (' + count + ')';
    }
  }

  function handleCreateList() {
    var input = pickerEl.querySelector('.spectrum-wl-picker__input');
    var name = input.value.trim();
    if (!name) return;

    var lib = getLib();
    if (!lib) return;

    var wasInAnyListBeforeCreate = isProductInAnyList();

    var btn = pickerEl.querySelector('.spectrum-wl-picker__create-btn');
    input.disabled = true;
    btn.disabled = true;

    lib.createWishlist(name).then(function(result) {
      input.disabled = false;
      btn.disabled = false;
      if (!result.ok) return;

      var newList = result.data;
      if (newList && newList.data) newList = newList.data;
      if (newList && newList.wishlist) newList = newList.wishlist;
      if (!newList || !newList.id) return;

      if (!newList.name) newList.name = name;
      if (!Array.isArray(newList.items)) newList.items = [];
      if (newList.itemCount == null) newList.itemCount = 0;

      pickerLists.push(newList);

      lib.addItem(newList.id, {
        shopifyProductGid: pickerGid,
        shopifyVariantGid: pickerVariantGid,
        handle: pickerHandle
      }).then(function(addResult) {
        if (addResult.ok) {
          var newItem = { shopifyProductGid: pickerGid, shopifyVariantGid: pickerVariantGid, handle: pickerHandle };
          var rd = addResult.data;
          if (rd) newItem.id = rd.id || (rd.data && rd.data.id) || null;
          newList.items.push(newItem);
          newList.itemCount++;
        }

        renderPickerLists(pickerLists, pickerGid);
        input.value = '';
        document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
          detail: { action: 'added', productGid: pickerGid, isInAnyList: true, wasInAnyList: wasInAnyListBeforeCreate }
        }));
      });
    });
  }

  /* ── Click Handler (delegated) ───────────────────────────────────────── */

  document.addEventListener('click', function(e) {
    var wrapper = e.target.closest('[data-spectrum-wishlist-btn]');
    if (!wrapper || wrapper.classList.contains('is-processing')) return;

    e.preventDefault();
    e.stopPropagation();

    var gid = wrapper.dataset.productGid;
    var variantGid = wrapper.dataset.variantGid || null;
    var handle = wrapper.dataset.productHandle || '';

    waitForLib(function(lib) {
      /* Logged-in users: open multi-list picker */
      if (isCustomerLoggedIn()) {
        openPicker(wrapper, lib, gid, variantGid, handle);
        return;
      }

      /* Guest users: SDK handles localStorage internally */
      var isWishlisted = wrapper.classList.contains('is-wishlisted');
      wrapper.classList.add('is-processing');
      wrapper.classList.toggle('is-wishlisted');

      var btnEl = wrapper.querySelector('button');
      if (btnEl) {
        btnEl.disabled = true;
        var newLabel = isWishlisted ? 'Add to wishlist' : 'Remove from wishlist';
        btnEl.setAttribute('aria-label', newLabel);
        btnEl.setAttribute('title', newLabel);
      }

      var apiCall = isWishlisted
        ? lib.removeByProduct(gid)
        : lib.addItem('default', { shopifyProductGid: gid, shopifyVariantGid: variantGid, handle: handle });
      var minDelay = new Promise(function(r) { setTimeout(r, 300); });

      Promise.all([apiCall, minDelay]).then(function(results) {
        var result = results[0];
        wrapper.classList.remove('is-processing');
        if (btnEl) btnEl.disabled = false;

        if (!result.ok) {
          wrapper.classList.toggle('is-wishlisted');
          if (btnEl) {
            var revertLabel = isWishlisted ? 'Remove from wishlist' : 'Add to wishlist';
            btnEl.setAttribute('aria-label', revertLabel);
            btnEl.setAttribute('title', revertLabel);
          }
          return;
        }

        document.dispatchEvent(new CustomEvent('spectrum:wishlist:updated', {
          detail: {
            action: isWishlisted ? 'removed' : 'added',
            productGid: gid,
            wasInAnyList: isWishlisted,
            isInAnyList: !isWishlisted
          }
        }));
      });
    }, 5);
  });

  /* ── Picker Close Events ─────────────────────────────────────────────── */

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && pickerEl && pickerEl.classList.contains('is-open')) {
      closePicker();
    }
  });

  document.addEventListener('click', function(e) {
    if (!pickerEl || !pickerEl.classList.contains('is-open')) return;
    if (e.target.closest('[data-spectrum-wishlist-btn]')) return;
    if (e.target.closest('.spectrum-wl-picker')) return;
    closePicker();
  });

  document.addEventListener('scroll', function() {
    if (pickerEl && pickerEl.classList.contains('is-open')) closePicker();
  }, { capture: true, passive: true });

  /* ── Cross-Component Sync ────────────────────────────────────────────── */

  var _countTimer = null;

  function debouncedCountSync() {
    clearTimeout(_countTimer);
    _countTimer = setTimeout(function() {
      if (!isCustomerLoggedIn()) {
        updateHeaderCount(getGuestGids().length);
        return;
      }
      waitForLib(function(lib) {
        lib.getWishlists().then(function(result) {
          var lists = extractWishlists(result);
          cachedWishlists = result.ok ? lists : null;
          var totalItems = 0;
          lists.forEach(function(l) {
            if (typeof l.itemCount === 'number') totalItems += l.itemCount;
            else if (Array.isArray(l.items)) totalItems += l.items.length;
          });
          updateHeaderCount(totalItems);
        });
      });
    }, 250);
  }

  function optimisticCountAdjust(delta) {
    var el = document.getElementById(HEADER_BADGE_ID) || document.getElementById('spectrum-wl-header-count');
    if (!el) return;
    var current = parseInt(el.textContent, 10) || 0;
    updateHeaderCount(Math.max(0, current + delta));
  }

  document.addEventListener('spectrum:wishlist:updated', function(e) {
    var detail = e.detail || {};
    document.querySelectorAll('[data-spectrum-wishlist-btn][data-product-gid="' + detail.productGid + '"]').forEach(function(el) {
      if (detail.isInAnyList !== undefined) {
        el.classList.toggle('is-wishlisted', detail.isInAnyList);
      } else if (detail.action === 'added') {
        el.classList.add('is-wishlisted');
      } else if (detail.action === 'removed') {
        el.classList.remove('is-wishlisted');
      }
    });
    if (detail.action === 'added' && !detail.wasInAnyList) {
      optimisticCountAdjust(1);
    } else if (detail.action === 'removed' && !detail.isInAnyList) {
      optimisticCountAdjust(-1);
    }
    debouncedCountSync();
  });

  /* ── Post-Merge Count Refresh ────────────────────────────────────────── */

  document.addEventListener('$spectrum:wishlist:merged', function() {
    syncWishlistState();
  });

  /* ── Init ─────────────────────────────────────────────────────────────── */

  function init() {
    hydrateGuestState();
    syncWishlistState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── bfcache restore ─────────────────────────────────────────────────── */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted && isCustomerLoggedIn()) syncWishlistState();
  });
})();
